import { store } from '@betacrew/jars-flux';
import { all, call, put, select, takeLatest, takeLeading, takeEvery } from 'redux-saga/effects';
import { addNotifications } from '../../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import { PAGE_STATE } from '../../../constants/constants';
import RecipientDataService from '../../../../../services/RecipientDataService';
import Payer from '../../../../../libs/utility/Payer';
import { componentKey, setBuyingPlan, setFirstConfirmationModalOpen, setHasEnoughRequests, setLoadingState, setPayWithPrepayModalOpen, setPrepayRequestModalOpen, setRequestedCount, setSecondRequestedCountModalOpen, setThirdProceedWithW9RequestModalOpen, setW9Fees } from './BulkW9RequestModalSlice';
import { W9_MODALS_LOADING_STATES } from './constants';
import { setShouldReloadPaginatedRecipientList } from '../RecipientListSlice';

export const { getW9RequestedCount, isDisplayPlansView, getW9Fees, requestBulkW9 } = {

    getW9RequestedCount: (payload) => {
        return {
            type: "W9_REQUEST/GET_W9_REQUESTED_COUNT",
            payload
        }
    },

    isDisplayPlansView: (payload) => {
        return {
            type: "W9_REQUEST/IS_DISPLAY_PLANS_VIEW",
            payload
        }
    },

    getW9Fees: (payload) => {
        return {
            type: "W9_REQUEST/GET_W9_FEES",
            payload
        }
    },

    requestBulkW9: (payload) => {
        return {
            type: "W9_REQUEST/REQUEST_BULK_W9",
            payload
        }
    },

}

function* getW9RequestedCountAsync(action) {
    try {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.GET_W9_REQUEST_COUNT_LOADING }))

        const { PayerID, RecipientIds, IsAllSelect } = action.payload;

        const data = {
            PayerID: PayerID || "",
            RecipientIds: RecipientIds || [],
            IsAllSelect: IsAllSelect,
        }

        const response = yield RecipientDataService.getW9RequestedCount(data);

        const { Data, Message, Status } = response?.data;

        if (Status) {

            yield put(setRequestedCount({
                bulkW9Requests: Data,
                AcceptedW9Requests: Payer.extractNumberFromW8W9Message(Message) || 0
            }))
            yield put(setSecondRequestedCountModalOpen(true))
            yield put(setFirstConfirmationModalOpen(false))
        } else {
            yield put(addNotifications({ heading: "Failed to get the requested Count" }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the requested Count", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.GET_W9_REQUEST_COUNT_READY }))
    }

}

function* isDisplayPlansViewAsync(action) {
    try {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.DISPLAY_PLANS_VIEW_LOADING }))
        const { RecipientIds = [], isSelectAll } = action?.payload;

        const response = yield RecipientDataService.isDisplayPlansView();

        const { Data, Message, Status } = response?.data;

        if (Status) {
            if (Data) {
                yield put(setHasEnoughRequests(true))
                yield put(setThirdProceedWithW9RequestModalOpen(true));
                yield put(setBuyingPlan(false))
            } else {
                yield put(setHasEnoughRequests(false))

                if (RecipientIds?.length > 1 || isSelectAll) {
                    yield put(setBuyingPlan(true))
                    yield put(setPrepayRequestModalOpen(true));
                } else {
                    yield put(setBuyingPlan(false));
                    yield put(setThirdProceedWithW9RequestModalOpen(true))
                }

                yield put(setSecondRequestedCountModalOpen(false));
            }
        } else {
            yield put(addNotifications({ heading: "Failed to get display plans", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get display plans", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.DISPLAY_PLANS_VIEW_READY }))
    }

}

function* getW9FeesAsync(action) {
    try {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.GET_W9_FEES_LOADING }));
        const { count } = action.payload;

        const response = yield RecipientDataService.getW8W9Fees(count);

        const { Data, Message, Status } = response?.data;

        if (Status) {
            yield put(setW9Fees(Data));
        } else {
            yield put(addNotifications({ heading: "Failed to get the W9 fees", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the W9 fees", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.GET_W9_FEES_READY }));
    }
}

function* requestBulkW9Async(action) {
    try {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.REQUEST_BULK_W9_LOADING }))

        const {
            RecipientIds,
            FormType = "W9",
            CommonCardHolderName = "",
            CommonCreditCardNumber = "",
            CommonCvvNumber = "",
            CommonExpiryMonth = "",
            CommonExpiryYear = "",
            TotalFee = "",
            Cardtype = "",
            Coupon = "",
            PrepaidAmount = "",
            commonisSaveCard = true,
            CommonSavedCard = null,
            w8W9PlanType = "",
            PaymentEmail = "",
            CommonBillingaddress = "",
            CommonCity = "",
            CommonZipcode = "",
            CommonState = "",
            CommonCountry = "",
            CommonContactEmail = "",
            isW8orW9Payment = "",
            IsBulkTin = "",
            totalAmount = "",
            prepay = "",
            showAdminAmount = "",
            saveCardId = "",
            saveCard = "",
            isPrepaid = "true",
            prepayless1 = "No",
            prepayFlag = "Yes",
            payerId = "",
            isAccountant = "true",
            selectAll = "",
        } = action.payload

        const data = {
            RecipientIds,
            FormType,
            w8W9PlanType,
            isW8orW9Payment,
            CommonCardHolderName,
            CommonCreditCardNumber,
            CommonCvvNumber,
            CommonExpiryMonth,
            CommonExpiryYear,
            TotalFee,
            Cardtype,
            Coupon,
            PrepaidAmount,
            commonisSaveCard,
            CommonSavedCard,
            PaymentEmail,
            CommonBillingaddress,
            CommonCity,
            CommonZipcode,
            CommonState,
            CommonCountry,
            CommonContactEmail,
            IsBulkTin,
            totalAmount,
            prepay,
            showAdminAmount,
            saveCardId,
            saveCard,
            isPrepaid,
            prepayless1,
            prepayFlag,
            payerId,
            selectAll,
            isAccountant
        }

        const response = yield RecipientDataService.requestBulkW9(data);
        const { Status, Message } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: "Success", message: "Bulk W9 request successful.", variant: TOASTER_VARIANT.SUCCESS }));
            yield put(setShouldReloadPaginatedRecipientList(true));

            yield put(setSecondRequestedCountModalOpen(false));
            yield put(setThirdProceedWithW9RequestModalOpen(false))
            yield put(setPayWithPrepayModalOpen(false))
        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "W9 Request Failed", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: W9_MODALS_LOADING_STATES.REQUEST_BULK_W9_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getW9RequestedCount().type, getW9RequestedCountAsync),
        takeLatest(isDisplayPlansView().type, isDisplayPlansViewAsync),
        takeLatest(getW9Fees().type, getW9FeesAsync),
        takeLatest(requestBulkW9().type, requestBulkW9Async),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);